import { render, staticRenderFns } from "./BandejaHcs.vue?vue&type=template&id=e383def8&scoped=true"
import script from "./BandejaHcs.vue?vue&type=script&lang=js"
export * from "./BandejaHcs.vue?vue&type=script&lang=js"
import style0 from "./BandejaHcs.vue?vue&type=style&index=0&id=e383def8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e383def8",
  null
  
)

export default component.exports